// extracted by mini-css-extract-plugin
export default {"statics":"Statics_statics__rRzX8","active":"Statics_active__nfUIn"};